import script from "./AppInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppInput.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__